import React from 'react';
import PropTypes from 'prop-types';
import styles from './Layout.module.css';
import {connect} from 'react-redux';
import { setLocale } from 'react-redux-i18n';
import packageJson from '../../../../package.json';

class Footer extends React.Component {
  changeLocalization(locale) {
    this.props.changeLocalization(locale);
  }

  render() {
    const {
      changeLocalization
    } = this.props;

    return     (<footer className={styles.footer}>
        <div className="container-fluid">
          <div className="float-start">
            <p>© SimsUShare (CTC v. { packageJson.version })</p>
          </div>
          <div className="float-end">
            <a href="#" onClick={changeLocalization.bind(null, 'es')}>ES</a>
            <a href="#" onClick={changeLocalization.bind(null, 'en')}>EN</a>
            <a href="#" onClick={changeLocalization.bind(null, 'fr')}>FR</a>
            <a href="mailto:info@simsushare.com">Contact us</a>
          </div>
        </div>
      </footer>);
  }
}
Footer.propTypes = {
  changeLocalization: PropTypes.func
};


const mapStateToProps = state => ({
});

const mapDispatchToProps = {
  changeLocalization: setLocale
};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
